import { ButtonAppearances as FabricButtonAppearances, ButtonShapes as FabricButtonShapes, ButtonSizes as FabricButtonSizes, ButtonFormTargets as FabricButtonFormTargets, ButtonTypes as FabricButtonTypes } from "../button/index.js";
/**
 * Appearances for {@link CompoundButton}
 * Local plural const composed from ButtonAppearances allowing future extensions.
 * @public
 */
export const CompoundButtonAppearances = {
    ...FabricButtonAppearances
};
/**
 * Shapes for {@link CompoundButton}
 * @public
 */
export const CompoundButtonShapes = {
    ...FabricButtonShapes
};
/**
 * Sizes for {@link CompoundButton}
 * @public
 */
export const CompoundButtonSizes = {
    ...FabricButtonSizes
};
/**
 * Form targets for {@link CompoundButton}
 * @public
 */
export const CompoundButtonFormTargets = {
    ...FabricButtonFormTargets
};
/**
 * Types for {@link CompoundButton}
 * @public
 */
export const CompoundButtonTypes = {
    ...FabricButtonTypes
};
//# sourceMappingURL=compound-button.options.js.map